/** Where the Patreon buttons and popups send people (the Patreon version of the subscribe page). */
export const PATREON_SUBSCRIBE_PATH = "/subscribe/patreon"
